import { render, staticRenderFns } from "./RefundRecord.vue?vue&type=template&id=22a8a3f8&scoped=true"
import script from "./RefundRecord.vue?vue&type=script&lang=js"
export * from "./RefundRecord.vue?vue&type=script&lang=js"
import style0 from "./RefundRecord.vue?vue&type=style&index=0&id=22a8a3f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a8a3f8",
  null
  
)

export default component.exports